import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "286",
  "slug": "spot-egypt-from-satellite-imagery",
  "title": "How to Recognise Egypt in Satellite Images",
  "excerpt": "The Nile forms a narrow cultivated corridor through arid land before widening into a delta at the Mediterranean coast.",
  "date": "2026-05-11",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/egypt.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The Nile forms a narrow cultivated corridor through arid land before widening into a delta at the Mediterranean coast. In a regional view, the green triangle of the delta contrasts with the surrounding desert. The Sinai Peninsula lies between the Gulf of Suez and the Gulf of Aqaba."
    },
    {
      "type": "heading",
      "text": "The Nile corridor and delta"
    },
    {
      "type": "paragraph",
      "text": "Start at the Mediterranean and trace the Nile inland. Compare the width of cultivated land in the delta with the much narrower corridor to the south."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Irrigated land beside a desert river is not unique to Egypt. A small field crop could resemble places farther up the Nile or elsewhere. The delta outline, river position, and neighbouring seas provide the stronger regional evidence."
    }
  ],
  "imageAlt": "Egypt regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
